import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  skeletonContainer: { width: '100%' },
  skeletonRow: { width: '100%', height: 40 }
}))

export default useStyles
